import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { clearFilterButton } from '~src/spacesPlatform/components/filterPanel/FilterPanelStyles';

export interface ClearFilterButtonProps {
  readonly filterName: string;
  readonly clearFilter: () => void;
  readonly getElementToRefocus: () => (HTMLElement | null);
}

export function ClearFilterButton(props: ClearFilterButtonProps) {
  return <ButtonWidget
    buttonType={ButtonType.LowEmphasis}
    children={Messages.clear()}
    className={clearFilterButton}
    style={{height: 20, fontWeight: 'normal', minWidth: 0}}
    onClick={() => {
      props.clearFilter();
      props.getElementToRefocus()?.focus();
    }}
    testId={`clear-filter-${props.filterName}`}
  />;
}
